import { Attachment } from 'models/attachments.model'
import api from '../..'

const coursesReminder = (id: string | number) =>
  api.post<string | Attachment>(`administration/users/${id}/courses_reminder`)

export default coursesReminder
